<template>
    <div 
        class="actions align-right" 
    >
        <template v-for="(action, idx) in environment.AllowedActions" :key="idx" >
            <button
                :disabled="!actionsEnabled || underprogress"
                @click="fireAction(action)"
            >
                {{ $t(action) }}
            </button>
        </template>
    </div>
    
</template>

<script>
import { mapGetters } from 'vuex';

import Swal from 'sweetalert2';
import {EventBus} from '@/utils/eventBus';

export default {
    name: 'z-actions',

    props: {
        environment: {
            type: Object,
            default: ()=>{
                return {};
            },
            required: true,
        }
        
    },

    data () {
        return {
            underprogress: false,
            actionsEnabled: true,
        };
    },

    computed: {
        ...mapGetters([
            'selectedRelease',
        ])
    },

    mounted() {
        EventBus.on('fetchEnvironmentUpdate', () => {
            this.actionsEnabled = true;
        });
    },

    methods: {

        async fireAction (action) {
            this.actionsEnabled = false;
            this.underprogress = true;
            const result = await Swal.fire({
                title: 'Confirming action',
                showConfirmButton: true,
                showCancelButton: true,
                html: `Are you sure run the following action?<br><ul>
                    <li>Release: ${this.selectedRelease.ReleaseDate}</li>
                    <li>Environment: ${this.environment.Environment}</li>
                    <li><strong>${action}</strong></li>
                    </ul>`,
                confirmButtonText: 'OK',
            });
            if(result.isConfirmed) {
                try {
                    const params = {
                        ReleaseDate: this.selectedRelease.ReleaseDate,
                        Environment: this.environment.Environment,
                        Action: action
                    };

                    const result = await this.$http.post('/deployment/action', params);
                    if (result.data.status == 'warning') {
                        const confirm = await Swal.fire({
                            title: 'Warning',
                            text: result.data.message,
                            confirmButtonText: 'Yes, confirm',
                            showCancelButton: true
                        });
                    } else if (result.data.status == 'error') {
                        const confirm = await Swal.fire({
                            title: 'Error occured',
                            text: result.data.message,
                            confirmButtonText: 'Okay',
                        });
                    } else {
                        Swal.fire({
                            title: 'Deployment',
                            text: result.data.message,
                            confirmButtonText: 'Acknowledged',
                        });
                        EventBus.emit('envcheck');
                    }
                    this.underprogress = false;
                } catch (e) {
                    EventBus.emit('progressbar:off');
                    Swal.fire({
                        title: 'Deployment',
                        type: 'warning',
                        text: `Failed to run the following action: ${action}!`,
                        confirmButtonText: 'OK',
                    });
                    EventBus.emit('envcheck');
                    this.underprogress = false;
                }
            } else {
                this.actionsEnabled = true;
                this.underprogress = false;
            }
        }

        
    }
};
</script>
